import { COLORS, TEXT_COLORS } from "../../constants/design/colors";

/**
 * Get color based on value (positive = green, negative = red, zero = default)
 */
export const getValueColor = (value: number): string => {
  if (value > 0) return COLORS.green.one;
  if (value < 0) return COLORS.red.one;
  return TEXT_COLORS.two;
};
